import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { TitleText } from '../../../../ui/Text';
import { Button } from '../../../../ui/Button';
import MeasuresTable from './MeasuresTable';
import { useParams } from 'react-router-dom';
import { GetHook } from '../../../../api/api';
import { SCORECARD_URL } from '../../../../api/urls';
import { get } from '../../../../utils/get';
import axios from '../../../../utils/axios';
import numeral from 'numeral';
import { jsPDF } from 'jspdf';
import { sortPerspectives } from '../../../../utils/sortPerspectives';
interface IProps {
  scorecardId?: string;
  scorecard?: any;
  closeModal?: any;
  ref?: any;
}
const Preview = ({ scorecardId, closeModal, scorecard }: IProps) => {
  const [display, setDisplay] = useState('none');
  const previewRef = useRef<any>();

  const { data: perspectives } = GetHook(
    `${SCORECARD_URL}/${scorecardId}/perspective/v1`
  );
  const { data: objectives } = GetHook(
    `${SCORECARD_URL}/${scorecardId}/objective/v1`
  );
  const { data: kpis } = GetHook(`${SCORECARD_URL}/${scorecardId}/kpi/v1`);

  const columns = [
    {
      Header: 'Measure name',
      accessor: 'kpi.name'
    },
    {
      Header: 'Type',
      accessor: 'kpi.score_type'
    },
    {
      Header: 'Target',
      accessor: 'target',
      Cell: ({ row }) => numeral(row.original.target).format('0a,0.00')
    },
    {
      Header: 'Weight',
      accessor: 'weight'
    },
    {
      Header: () => <TitleText color='#D51067'>0</TitleText>,
      accessor: 'score_distribution.0',
      Cell: ({ row }) =>
        row.original?.score_distribution
          ? numeral(row.original?.score_distribution['0']).format('0a,0.00')
          : '0.00'
    },
    {
      Header: () => <TitleText color='#D51067'>1</TitleText>,
      accessor: 'score_distribution.1',
      Cell: ({ row }) =>
        row.original?.score_distribution
          ? numeral(row.original?.score_distribution['1']).format('0a,0.00')
          : '0.00'
    },
    {
      Header: () => <TitleText color='#EDBC0C'>2</TitleText>,
      accessor: 'score_distribution.2',
      Cell: ({ row }) =>
        row.original?.score_distribution
          ? numeral(row.original?.score_distribution['2']).format('0a,0.00')
          : '0.00'
    },
    {
      Header: () => <TitleText color='#EDBC0C'>3</TitleText>,
      accessor: 'score_distribution.3',
      Cell: ({ row }) =>
        row.original?.score_distribution
          ? numeral(row.original?.score_distribution['3']).format('0a,0.00')
          : '0.00'
    },
    {
      Header: () => <TitleText color='#4BD041'>4</TitleText>,
      accessor: 'score_distribution.4',
      Cell: ({ row }) =>
        row.original?.score_distribution
          ? numeral(row.original?.score_distribution['4']).format('0a,0.00')
          : '0.00'
    },
    {
      Header: () => <TitleText color='#4BD041'>5</TitleText>,
      accessor: 'score_distribution.5',
      Cell: ({ row }) =>
        row.original?.score_distribution
          ? numeral(row.original?.score_distribution['5']).format('0a,0.00')
          : '0.00'
    }
  ];

  const sortedPerspectives = sortPerspectives(perspectives);

  function printDiv() {
    const html = previewRef.current;
    const width = html.clientWidth;
    const height = html.clientHeight;

    setDisplay('flex');

    const doc = new jsPDF('p', 'pt', [795.26, 995]);

    doc.html(html, {
      html2canvas: {
        scale: 795.26 / width,
        scrollY: 0
      },
      callback: function () {
        doc.setFontSize(9);
        doc.save('scorecard preview.pdf');
        // window.open(doc.output('bloburl')); // To debug.
        setDisplay('none');
      }
    });
  }

  return (
    <>
      <PrintButton text='print' onClick={() => printDiv()} />
      <Container id='print_to_pdf' ref={previewRef}>
        <Header style={{ display: display }}>
          <TitleText style={{ fontSize: 18 }}>{scorecard[0]?.owner}</TitleText>
          <TitleText style={{ fontWeight: 400, fontSize: 16 }}>
            {get(scorecard, '[0]owner.job_title', '')}
          </TitleText>{' '}
          <TitleText style={{ fontWeight: 400, fontSize: 14 }}>
            {scorecard[0]?.period_name}
            {get(scorecard, '[0]period_name', '--')}
          </TitleText>{' '}
          <TitleText>
            {/* {get(scorecard, "[0]name")} */}
            <span style={{ fontSize: 14, fontWeight: 300, color: 'gray' }}>
              {' '}
              {get(scorecard, '[0]status')}
            </span>
          </TitleText>
        </Header>
        {sortedPerspectives &&
          sortedPerspectives.map(perspective => {
            const objectivesArray = objectives.filter(
              objective =>
                get(objective, 'objective.perspective_id') ===
                get(perspective, 'perspective_id')
            );

            return (
              <PerspectiveContainer>
                <TitleText style={{ fontSize: '16px' }}>
                  {get(perspective, 'perspective.name')}
                  <h6 style={{ margin: 0 }}>
                    (Weight: {get(perspective, 'weight')})
                  </h6>
                </TitleText>
                <DetailsContainer>
                  {objectives
                    .filter(
                      objective =>
                        get(objective, 'objective.perspective_id') ===
                        get(perspective, 'perspective_id')
                    )
                    .map(objective => {
                      const kpisArr = kpis.filter(
                        kpi =>
                          kpi.kpi.objective_id ===
                          get(objective, 'objective_id')
                      );
                      return (
                        <ObjectiveContatiner>
                          <TitleText style={{ fontSize: '16px' }}>
                            Objective {`>`} {get(objective, 'objective.name')}
                            <h6 style={{ margin: 0 }}>
                              (Weight: {get(objective, 'weight')})
                            </h6>
                          </TitleText>
                          <MeasuresTable
                            columns={columns}
                            data={kpis.filter(
                              kpi =>
                                kpi.kpi.objective_id ===
                                get(objective, 'objective_id')
                            )}
                          />
                        </ObjectiveContatiner>
                      );
                    })}
                </DetailsContainer>
              </PerspectiveContainer>
            );
          })}
      </Container>
    </>
  );
};

export default Preview;

const Container = styled.div`
  display: grid;
  background-color: #f5f6fb;
  padding: 1em;
  border-radius: 1em;
`;

const Header = styled.div`
  flex-direction: column;
  /* align-items: center;
  justify-content: space-between; */
  padding-bottom: 1em;
  border-bottom: 1px solid #ccc;
  ${TitleText} {
    margin-right: 16em;
  }
`;

const PerspectiveContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  ${TitleText} {
    padding-bottom: 1em;
    padding-top: 1em;
  }
`;

const DetailsContainer = styled.div`
  background-color: #fff;
  padding: 1em;
  border-radius: 0.5em;
`;

const ObjectiveContatiner = styled.div`
  display: grid;
  /* grid-template-rows: 1fr auto; */
`;
const PrintButton = styled(Button)`
  width: 5%;
  margin-left: auto;
  margin-bottom: 1em;
`;
